import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router';

const propTypes = { url: PropTypes.string };
const defaultProps = { url: '' };

function BackButton({ url }) {
    const history = useHistory();

    return (
        <Box my={2}>
            <Button
                size="large"
                onClick={() => (url ? history.push(url) : history.goBack())}
                startIcon={<BackIcon />}
            />
        </Box>

    );
}

BackButton.propTypes = propTypes;
BackButton.defaultProps = defaultProps;

export default BackButton;
